import React from "react";

import Copyright from "./Copyright";
import ContactInfo from "./ContactInfo";
import { FormattedMessage } from "react-intl";

const Footer = props => {
  return (
    <section id="footer">
      <div className="inner">
        <h2 className="major">
          {props.language === "es" ? "Contacto" : "Contact us"}
        </h2>
        <p>
          <FormattedMessage id="footermsg" />
        </p>
        <ContactInfo />
        <Copyright />
      </div>
    </section>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js